import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listWorkRoutesListService } from "../service/listWorkRoutesList.service";

const LIMIT = 25;

export const useWorkRoutesListQuery = (filters) => {
  const fetchData = useFetch();
  const [workRoutesList, setWorkRoutesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchWorkRoutesList = async () => {
      setLoading(true);
      try {
        const response = await listWorkRoutesListService(fetchData)({
          offset: (page - 1) * LIMIT,
          limit: LIMIT,
          ...filters,
        });
        setWorkRoutesList(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error("Error fetching work routes list:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchWorkRoutesList, 500);
    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, refresh]);

  return {
    workRoutesList,
    loading,
    page,
    onChangePage: (newPage) => setPage(newPage),
    total,
    totalPages,
    refresh: () => setRefresh((prev) => !prev),
  };
};
